import {UpdateDomainE164RangesMutationVariables} from "@/components/domain_settings/allocated-e164-ranges/mutations.generated";

export function createInitialData(domainId: number, ranges?: string): UpdateDomainE164RangesMutationVariables {
    if (!ranges)
        return {
            id: 0,
            ranges: [],
        };

    const parsedRanges = JSON.parse(ranges);

    return {
        id: domainId,
        ranges: parsedRanges.map((range: [string, string]) => ({
            start: range[0],
            end: range[1],
        })),
    };
}
